import * as api from 'syft-acp-core/api/resources/admin/workers'
import { takeLatestApiCall } from './helpers'

export default function* root() {
  yield takeLatestApiCall('WORKER_COMPLETED_SHIFTS_FETCH', api.fetchCompletedShifts)
}
